import { FloatingLabelSelectOption } from "../Types/Form/FloatingLabelSelectOption";
import { axiosInstance } from "../Authentication/AxiosInterceptor";
import { ProductType } from "../Types/ProductType";

const getProductTypeNameForAPI = (type: ProductType): string => {
  switch(type) {
    case ProductType.Evaluate: return "Evaluate";
    case ProductType.Enquire: return "Enquire";
    case ProductType.Improve: return "Improve";
    case ProductType.Develop: return "Develop";
    default: return "Evaluate";
  }
};

export const getRolesOptions = async (clientId: string, productType: ProductType): Promise<FloatingLabelSelectOption[]> => {
  try {
    const response = await axiosInstance.get(`GetProductInvitableRoles/${clientId}/${getProductTypeNameForAPI(productType)}`);
    
    if (response.status === 204 || !response.data || !Array.isArray(response.data)) {
      return [];
    }

    return response.data.map((role: string) => ({
      value: role,
      label: role,
    }));
  } catch (error: any) {
    if (error.response?.status === 204) {
      return [];
    }
    console.error("Error fetching roles:", error);
    return [];
  }
};
